'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightBoxComponent = exports.defaultStyles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lightboxReact = require('lightbox-react');

var _lightboxReact2 = _interopRequireDefault(_lightboxReact);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable jsx-a11y/no-static-element-interactions */


var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

var LightBoxComponent = exports.LightBoxComponent = function (_Component) {
  _inherits(LightBoxComponent, _Component);

  function LightBoxComponent(props) {
    _classCallCheck(this, LightBoxComponent);

    var _this = _possibleConstructorReturn(this, (LightBoxComponent.__proto__ || Object.getPrototypeOf(LightBoxComponent)).call(this, props));

    _this.handleButtonPress = function (e) {
      if (e.key && e.key === 'Enter' || !e.key) {
        _this.setState({ isOpen: true, photoIndex: 0 });
      }
    };

    _this.state = {
      photoIndex: 0,
      isOpen: false
    };
    _this.handleChildClick = _this.handleChildClick.bind(_this);
    return _this;
  }

  _createClass(LightBoxComponent, [{
    key: 'handleChildClick',
    value: function handleChildClick(event) {
      var index = void 0;
      var element = event.target;

      while (!index && element && element !== this.ref) {
        if ((0, _lodash.get)(element, 'dataset.index')) {
          index = (0, _lodash.get)(element, 'dataset.index');
        } else {
          element = element.parentNode;
        }
      }

      if (index) {
        this.setState({ isOpen: true, photoIndex: parseInt(index, 10) });
      } else if (!this.props.onlyWithIndex) {
        this.setState({ isOpen: true, photoIndex: 0 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          button = _props.button,
          children = _props.children,
          className = _props.className,
          enableZoom = _props.enableZoom,
          imageThumbnailUrlOptions = _props.imageThumbnailUrlOptions,
          items = _props.items,
          wrap = _props.wrap;
      var _state = this.state,
          isOpen = _state.isOpen,
          photoIndex = _state.photoIndex;


      var nextIndex = wrap ? (photoIndex + 1) % items.length : photoIndex + 1;
      var prevIndex = wrap ? (photoIndex + (items.length - 1)) % items.length : photoIndex - 1;

      return _react2.default.createElement(
        'div',
        { onClick: this.handleChildClick, className: className, ref: function ref(_ref) {
            _this2.ref = _ref;
          } },
        !!button && _react2.default.createElement(
          'span',
          {
            className: 'LightBox_button',
            onClick: this.handleButtonPress,
            onKeyUp: this.handleButtonPress,
            role: 'button',
            tabIndex: '0'
          },
          button
        ),
        children,
        isOpen && _react2.default.createElement(_lightboxReact2.default, {
          mainSrc: (0, _lodash.get)(items, '[' + photoIndex + '].element', (0, _bdcoreUtilities.buildThumbnailUrl)((0, _lodash.get)(items, '[' + photoIndex + '].contentUrl'), imageThumbnailUrlOptions)),
          imageTitle: (0, _lodash.get)(items, '[' + photoIndex + '].caption'),
          imageCaption: (0, _lodash.get)(items, '[' + photoIndex + '].name'),
          enableZoom: enableZoom,

          nextSrc: items[nextIndex],
          prevSrc: items[prevIndex],

          onCloseRequest: function onCloseRequest() {
            return _this2.setState({ isOpen: false });
          },
          onMovePrevRequest: function onMovePrevRequest() {
            return _this2.setState({
              photoIndex: (photoIndex + (items.length - 1)) % items.length
            });
          },
          onMoveNextRequest: function onMoveNextRequest() {
            return _this2.setState({
              photoIndex: (photoIndex + 1) % items.length
            });
          }
        })
      );
    }
  }]);

  return LightBoxComponent;
}(_react.Component);

LightBoxComponent.propTypes = {
  button: _propTypes2.default.node,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  enableZoom: _propTypes2.default.bool,
  imageThumbnailUrlOptions: _propTypes2.default.shape({
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    exact: _propTypes2.default.bool,
    preserve: _propTypes2.default.bool
  }),
  items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object])).isRequired,
  onlyWithIndex: _propTypes2.default.bool,
  /** Next and Prev buttons wrap around to first/last item */
  wrap: _propTypes2.default.bool
};

LightBoxComponent.defaultProps = {
  button: undefined,
  children: undefined,
  className: '',
  enableZoom: false,
  imageThumbnailUrlOptions: { width: 2000, height: 2000 },
  onlyWithIndex: false,
  wrap: false
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(LightBoxComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-lightbox/build/LightBox.js
// module id = 1203
// module chunks = 0